module.exports = __webpack_public_path__ + "static/media/social-03.39fffd5e.png";